<template>
  <div id="table-body">

    <div class="table-caption">
      <div class="table-title"> 
        <span v-html="title" />
        <a v-if="!!nutri_info" class="button-icon" v-b-toggle.collapse-1><b-icon-question /></a>
        <a v-b-modal.modal-item-request class="button-icon float-right"><b-icon-plus-square /></a>
        <b-modal 
          id="modal-item-request"
          title="상품 등록"
          @ok="request"
        >
          <request-modal ref='request'/>
        </b-modal>
      </div>
      <div v-if="!!nutri_info">
        <b-collapse id="collapse-1" class="mt-2">
          <b-card class="nutri-info-card">
            <p class="nutri-info" v-for="(info, key) in nutri_info" :key=key>
              {{info}}
            </p>
          </b-card>
        </b-collapse>
      </div>
    </div>
    <div class="item-table-wrapper">
      <b-table 
        class="item-table"
        striped
        caption-top
        show-empty
        :no-local-sorting="true"
        :busy="loading"
        :items="items"
        :fields="fields"
        :sort-by.sync="sort_by"
        :sort-desc.sync="sort_desc"
        @sort-changed="sortingChanged"
        empty-text="조건에 해당하는 상품이 없습니다."
      >
        <template v-slot:cell(index)="data">
          <b-badge :class="'rank rank'+data.index">
            {{ data.index + 1 }}위
          </b-badge>
        </template>
        <template v-slot:cell(name)="row">
          <router-link :to="`/item/${row.item._id}`">{{row.item.name.length > 50?row.item.name.slice(0, 50) + '...':row.item.name}}</router-link>
        </template>
        <template v-slot:cell(norm_amount)="data">
          <div class="text-right bold"><b>{{numberWithCommas((data.value * 100).toFixed(2))}} {{nutri_unit}}</b></div>
        </template>
        <template v-slot:cell(total_amount)="data">
          <div class="text-right"><b>{{numberWithCommas(data.value.toFixed(0))}} {{nutri_unit}}</b></div>
        </template>
        <template v-slot:cell(amount)="data">
          <div class="text-right">{{data.value}}</div>
        </template>
        <template v-slot:cell(daily_amount)="data">
          <div class="text-right">{{numberWithCommas(data.value)}} {{nutri_unit}} </div>
        </template>
        <template v-slot:cell(nutri_amount)="data">
          <div class="text-right">{{numberWithCommas(Math.round(data.value * 100) / 100 )}} {{nutri_unit}}</div>
        </template>
        <template v-slot:cell(price)="data">
          <div class="text-right">{{numberWithCommas(data.value.toFixed(0))}}원</div>
        </template>
        <template v-slot:table-busy>
          <div class="spinner-wrapper">
            <b-spinner variant="primary" label="Spinning" />
            <strong>Loading...</strong>
          </div>
        </template>
        <template v-slot:empty="scope">
          <div class="empty-text">{{ scope.emptyText }}</div>
        </template>
      </b-table>
    </div>
  </div>
</template>

<script>
import util from '../util'
import { mapGetters, mapState } from 'vuex'
import { mapSetters } from '../store/util'
import RequestModal from './common/RequestModal'
import {
    BRow, BCol, BTable, BBadge, BFormGroup, BFormRadioGroup, BFormRadio, BFormCheckboxGroup, BSpinner, BCollapse, BModal,
    BIconChevronDown, BIconQuestion, BIconX, BIconFilter, BIconListOl, BIconPlusSquare
} from 'bootstrap-vue'

var filterKeys = ['sort_by', 'sort_desc']

export default {
  name: 'ItemTableComponent',
  components: {
    BRow, BCol, BTable, BBadge, BFormGroup, BFormRadioGroup, BFormRadio, BFormCheckboxGroup, BSpinner, BCollapse, BModal,
    BIconChevronDown, BIconQuestion, BIconX, BIconFilter, BIconPlusSquare,
    RequestModal
  },
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    type: {
      type: String
    },
    title: {
      type: String,
      default: ''
    },
    fields: {
      type: Array,
      default: () => [
        { key: 'index', label: '순위', class: "td-rank"},
        { key: 'name', label: '상품명', sortable: true, class: 'td-name'},
        {
          key: 'norm_amount',
          label: '100원 당 함유량',
          sortable: true,
          class:'td-norm-amount'
        },
        {
          key: 'total_amount',
          label: '전체 함유량',
          sortable: true,
          class: 'td-total-amount'
        },
        { key: 'amount', label: '수량', sortable: true},
        { key: 'daily_amount', label: '1일권장량', sortable: true},
        { key: 'nutri_amount', label: '1일함유량', sortable: true},
        { key: 'price', label: '최저가', sortable: true}
      ]
    }
  },
  computed: {
    ...mapState({
      items: state => state.item.list
    }),
    ...mapGetters('item', {
      item_count: 'count'
    }),
    ...mapGetters('filter', {
      nutri: 'nutri'
    }),
    ...mapSetters(
      mapState('filter', filterKeys),
      filterKeys.reduce((setters, key) => {
        setters[key] = function(value) {}
        return setters
      }, {})
    ),
    isMobile () {
      return this.$store.isMobile
    },
    nutri_name () {
      if (this.nutri)  return this.nutri.name
    },
    nutri_unit () {
      if (this.nutri)  return this.nutri.unit
    },
    nutri_info () {
      if (this.nutri)  return this.nutri.info
    }
  },
  methods: {
    sortingChanged(ctx) {
      let path = this.$route.path
      let params = this.$route.params
      let query = Object.assign({}, this.$route.query)
      query.sort_by = ctx.sortBy
      query.sort_desc = String(ctx.sortDesc)
      this.$router.push({path, params, query})
    },
    numberWithCommas(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    request() {
      this.$refs.request.submit().then( res => {
        alert('상품 등록 요청이 완료되었습니다.')
      })
    },
  }
}
</script>
<style>
@media only screen and (max-width: 600px) {
  .item-table-wrapper {
    width: 90vw;
  }
  .td-rank {
    width: 10vw !important;
  }
  .td-name {
    width: 45vw !important;
    text-overflow: ellipsis; 
    overflow: hidden; 
    /* white-space:nowrap; */
  }
  .td-norm-amount {
    width: 25vw !important;
  }
  .empty-text {
    text-align: left !important;
  }
  .spinner-wrapper {
    text-align: left !important;
  }
} 
.td-rank {
  width: 5vw;
}
.td-name {
  width: 30vw;
}
</style>
<style scoped>
.item-table-wrapper {
  overflow: auto;
  min-height: 45vh;
  margin-bottom: 30px;
}
.item-table-wrapper > div {
  margin: 0;
}

.table-title {
  width: 80vw;
  font-size: 1.3rem;
  color: #000;
  margin: 20px 0;
}
.item-table-col {
  padding: 0; 
}
.item-table {
  min-width: 800px;
  /* width: auto; */
}
.item-table >>> td {
  vertical-align: middle;
  color: rgb(0,0,0, 0.8);
}
.item-table >>> tr:nth-child(-n+3) > td {
  height: 80px;
  background: rgba(203, 240, 255, 0.247);
  font-size: 0.9rem;
}
.td-name {
  width: 30vw;
}
.td-name > b > a {
  color: #000;
}

.empty-text {
  text-align: center;
}
.rank {
  font-size: 0.9rem;
}
.rank0 {
  background: gold;
  color: black;
  font-size: 1rem;
}
.rank1 {
  background: silver;
  color: black;
  font-size: 1rem;
}
.rank2 {
  background: #cd7f32;
  color: black;
  font-size: 1rem;
}
.nutri-info {
  margin: 5px;
}
.nutri-info-card {
  width: 80vw;
  color: #000;
}
.nutri-info-card > .card-body {
  padding: 0.5rem;
}
.nutri-info:first-child {
  font-weight: bold;
}
</style>


// WEBPACK FOOTER //
// src/components/ItemTable.vue